export enum ScormVersion {
  SCORM_1_2 = 'scorm1.2',
  SCORM_2004 = 'scorm2004',
}
